import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";

export const PrivacyPolicy = () => {
  React.useEffect(() => {
    document.title = "Privacy Policy – Wealthies";
  }, []);

  return (
    <>
      <TopBanner content={"Privacy Policy"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Privacy Policy</h2>
          <p>
            This Privacy Policy explains how Wealthies collects, uses, and
            protects information when users visit our website or submit
            inquiries.
          </p>

          <h3>1. Introduction</h3>
          <p>
            Wealthies is operated by Shreeman Assure Services Pvt Ltd. We
            respect the privacy of our users and are committed to protecting
            personal information collected through our platform.
          </p>
          <p>
            By using the Wealthies website, you agree to the practices described
            in this Privacy Policy.
          </p>

          <h3>2. Information We Collect</h3>
          <p>When users interact with our website, we may collect:</p>
          <ul>
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>City or location details</li>
            <li>Insurance interests or inquiry details</li>
            <li>Any information voluntarily submitted through forms</li>
          </ul>
          <p>We may also collect technical data such as:</p>
          <ul>
            <li>IP address</li>
            <li>Device type</li>
            <li>Browser information</li>
            <li>Website usage data</li>
          </ul>

          <h3>3. How We Use Information</h3>
          <ul>
            <li>Responding to user inquiries</li>
            <li>Connecting users with licensed insurance professionals</li>
            <li>Providing insurance awareness information</li>
            <li>Improving website functionality and user experience</li>
            <li>Communicating important updates related to services</li>
          </ul>

          <h3>4. Sharing of Information</h3>
          <p>
            We may share user information with licensed insurance professionals
            when users request assistance or advisor connection.
          </p>
          <p>
            We do not sell personal data to third parties for unrelated
            marketing purposes.
          </p>
          <p>
            Information may be shared if required by law or regulatory
            authorities.
          </p>

          <h3>5. Data Security</h3>
          <p>
            We take reasonable measures to protect user information from
            unauthorized access, misuse, or disclosure. However, no internet
            transmission is completely secure, and users should exercise caution
            when sharing personal information online.
          </p>

          <h3>6. Cookies and Website Analytics</h3>
          <p>
            The Wealthies website may use cookies or analytics tools to
            understand user behaviour and improve website performance.
          </p>
          <p>
            Users may disable cookies through browser settings if preferred.
          </p>

          <h3>7. User Rights</h3>
          <p>
            Users may request correction or deletion of personal information
            submitted through our website by contacting us.
          </p>

          <h3>8. Updates to Privacy Policy</h3>
          <p>
            This Privacy Policy may be updated periodically to reflect changes
            in business practices or regulatory requirements.
          </p>

          <h3>9. Contact Information</h3>
          <p>
            For questions related to privacy or data protection, users may
            contact:
          </p>
          <p>Shreeman Assure Services Pvt Ltd</p>
          <p>Bangalore, India</p>
          <p>Email: contact@wealthies.in</p>
        </div>
      </ContentWrapper>
    </>
  );
};

export default PrivacyPolicy;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
